<template>
  <div>
    <div class="cs-autonomousWorkflowList">
      <el-row v-if="USERMANAGER.isStudent">
        <el-col :span="24" v-if="inProgressCount > 0" class="cs-autonomousWorkflowList-inProgressCount">
          <span>您有{{inProgressCount}}笔账单未支付，为确保能正常上课，请尽快缴付账单</span>
        </el-col>
      </el-row>
      <div v-else>
        <el-row>
          <el-col :span="4">
            <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search" v-model.trim="condition.phone"
              @keyup.enter.native="onSearch()"></el-input>
          </el-col>

          <el-col :span="20" class="text-right">
            <el-button size="medium" type="primary" @click="onSearch()" class="margin-left-20px">搜索</el-button>
          </el-col>
        </el-row>
        <el-row class="margin-top-10">
          <el-col :span="4">
            <el-select placeholder="大学" v-model="condition.groupNumber" size="medium" filterable>
              <el-option v-for="item in universityGroups" :key="item.GroupNumber" :label="item.NameValue" :value="item.GroupNumber">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select placeholder="课程类型" v-model="condition.courseType" size="medium" @change="onCourseTypeChange" class="margin-left-20px">
              <el-option v-for="item in courseTypeList" :key="item.Key" :label="item.Value" :value="item.Key">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4"
            v-if="[GLOBAL.courseType.english, GLOBAL.courseType.vocationalTraining, GLOBAL.courseType.newStudentGuide].contains(condition.courseType)">
            <el-select placeholder="业务" v-model="condition.category" size="medium" class="margin-left-20px" :loading="isLoadingCategoryList">
              <el-option v-for="item in categoryList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4" v-show="!USERMANAGER.isInternationalSales" v-if="!condition.courseType || [GLOBAL.courseType.university, GLOBAL.courseType.vocationalTraining].contains(condition.courseType)">
            <el-select placeholder="类型" v-model="condition.type" size="medium" class="margin-left-20px">
              <el-option v-for="item in typeList" :key="item.key" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select placeholder="支付状态" v-model="condition.status" size="medium" class="margin-left-20px">
              <el-option v-for="item in statusList" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <pagination v-loading="loading" :data="listData" :option="paginationOption" @search="search" @loadData="onLoadList" @pageSizeChange="pageSizeChange"
        @currentPageChange="currentPageChange" @edit="onEdit" @additional="onAdditional"></pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-autonomousWorkflowList {
  .cs-autonomousWorkflowList-inProgressCount {
    background-color: #fbf0f0;
    color: red;
    line-height: 40px;
    span {
      display: block;
      margin-left: 20px;
    }
  }
}
</style>

<script>
import pagination from "../common/pagination";
import {
  getUniversityGroups,
  getTrainingCategoryList,
  createPaymentRefund,
} from "../../service/common.service";
import { getAutonomousPaymentWorkflowList } from "../../service/enrollmentFee.service";
import {
  getAutonomousWorkflowStatusList,
  getCourseTypeList,
} from "@/config/mUtils";

export default {
  props: {},
  data() {
    return {
      loading: false,
      listData: [],
      pageSize: 20,
      paginationOption: {},
      universityGroups: [],
      condition: {
        courseType: "",
        category: "",
        phone: "",
        groupNumber: "",
        status: "",
        type: "",
      },
      statusList: [],
      typeList: [
        { key: "", value: "所有账单类型" },
        { key: 1, value: "占位" },
        { key: 2, value: "课程报名" },
      ],
      inProgressCount: 0,
      courseTypeList: [],
      allCategoryList: {},
      categoryList: [],
      isLoadingCategoryList: false,
    };
  },
  components: {
    pagination,
  },
  created() {
    let courseTypeList = getCourseTypeList();
    if (!this.USERMANAGER.isVocationalTrainingManager) {
      courseTypeList.splice(0, 0, { Key: "", Value: "所有课程类型" });
      this.courseTypeList = courseTypeList;
    } else {
      this.courseTypeList = courseTypeList.filter(
        (i) => i.Key === this.GLOBAL.courseType.vocationalTraining
      );
      this.condition.courseType = this.GLOBAL.courseType.vocationalTraining;
      this.loadCategoryList();
    }

    this.statusList = getAutonomousWorkflowStatusList(true);

    let columns = [];
    if (!this.USERMANAGER.isStudent) {
      columns.push({
        name: "Edit",
        title: "",
        buttonText: "编辑",
        fnVisible: this.onRowEditVisible,
      });

      // //测试用
      // columns.push({
      //   name: "Refund",
      //   title: "",
      //   buttonText: "退款",
      //   fnVisible: this.onRowRefundVisible,
      // });
    }

    this.paginationOption = {
      displayPagination: true,
      hasEditButton: true,
      editButtonText: "账单详情",
      hasAddButton: false,
      hasSearch: false,
      hasDeleteButton: false,
      buttonWidth: 100,
      isNotStudent: !this.USERMANAGER.isStudent,
      additionalColumns: columns,
    };

    getUniversityGroups().then((result) => {
      if (!!result && result.success) {
        this.universityGroups = result.data;
        this.universityGroups.splice(0, 0, {
          GroupNumber: -1,
          NameValue: "不限大学",
        });
      }
      this.condition.groupNumber = -1;
    });
    this.search();
  },
  methods: {
    async createPaymentRefundToServer(workflowId) {
      try {
        let result = await createPaymentRefund(workflowId);
        if (!result || !result.success || !result.data) {
          this.$message.error("退款失败");
          return;
        }

        this.$message.success("退款成功");
      } catch (error) {
        console.error(error);
      }
    },

    onRowEditVisible(index, row) {
      if (this.USERMANAGER.isStudent) return false;
      return !row.IsCompleted;
    },
    //测试用
    onRowRefundVisible(index, row) {
      if (this.USERMANAGER.isStudent) return false;

      return true;
    },
    onCourseTypeChange() {
      if (this.condition.courseType !== this.GLOBAL.courseType.university) {
        this.loadCategoryList();
      }
      this.condition.category = "";
      this.condition.type = "";
    },
    loadCategoryList() {
      let courseType = this.condition.courseType;
      if (this.allCategoryList[courseType]) {
        this.categoryList = this.allCategoryList[courseType];
        return;
      }
      this.allCategoryList[courseType] = [];
      this.isLoadingCategoryList = true;
      getTrainingCategoryList(this.condition.courseType).then((result) => {
        if (!!result && result.success) {
          let categoryList = result.data;
          categoryList.splice(0, 0, {
            Id: "",
            Name: "所有业务",
          });
          this.allCategoryList[courseType] = categoryList;
          this.categoryList = categoryList;
        }
        this.isLoadingCategoryList = false;
      });
    },
    onEdit(index, row) {
      this.$emit("view", row.EnrollmentType, row.AccountId);
    },
    onSearch() {
      this.search();
    },
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.loadListData(pageData);
    },
    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    loadListData(pageData) {
      this.loading = true;
      getAutonomousPaymentWorkflowList(pageData)
        .then((result) => {
          if (!!result && result.success) {
            this.listData = result.data;
            if (
              this.listData.AdditionalResult &&
              this.listData.AdditionalResult["inProgressCount"]
            ) {
              this.inProgressCount =
                this.listData.AdditionalResult["inProgressCount"];
            } else {
              this.inProgressCount = 0;
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let additionalFilter = {
        groupNumber: this.condition.groupNumber,
        status: this.condition.status,
        type: this.condition.type,
        courseType: this.condition.courseType,
        category: this.condition.category,
      };
      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.condition.phone,
        additionalFilter: additionalFilter,
      };

      return pageData;
    },
    onAdditional(name, index, row) {
      switch (name) {
        case "Edit": {
          let path = "";
          if (row.EnrollmentType == 1) {
            path = "/addCollectFees/advanceEnrollmentFee";
          } else {
            path = "/addCollectFees/courseEnrollmentFee";
          }
          this.$router.push({
            path: path,
            query: {
              studentId: row.StudentId,
              workflowId: row.Id,
            },
          });
          break;
        }
        case "Refund": {
          this.createPaymentRefundToServer(row.Id);
          break;
        }
      }
    },
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/autonomousWorkflowList.vue